import React from 'react';
import HomePageSEOSetting from 'src/constrains/SalesChannelContent-Revamp/HomepageSEOSetting';
import { seoSetting } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepageResponsive/constants';
import ContentCarouselRender from '../../../constrains/SalesChannelContent-Revamp/Modules/ContentCarousel';
import ContentGridRender from '../../../constrains/SalesChannelContent-Revamp/Modules/ContentGrid';
import ContentTabRender from '../../../constrains/SalesChannelContent-Revamp/Modules/ContentTab';
import IframeRender from '../../../constrains/SalesChannelContent-Revamp/Modules/Iframe';
import ImageCarouselRender from '../../../constrains/SalesChannelContent-Revamp/Modules/ImageCarousel';
import PosterRender from '../../../constrains/SalesChannelContent-Revamp/Modules/Poster';
import PosterTabRender from '../../../constrains/SalesChannelContent-Revamp/Modules/PosterTab';
import ProductCarouselRender from '../../../constrains/SalesChannelContent-Revamp/Modules/ProductCarousel';
import ProductGridRender from '../../../constrains/SalesChannelContent-Revamp/Modules/ProductGrid';
import ProductTabRender from '../../../constrains/SalesChannelContent-Revamp/Modules/ProductTab';
import SubscriptionRender from '../../../constrains/SalesChannelContent-Revamp/Modules/Subscription';
import TextRender from '../../../constrains/SalesChannelContent-Revamp/Modules/Text';
import { seoSettingKey } from './constants';

import ErrSection from '@/src/components/Modules-revamp/ErrorSection';
import Visible from '@/src/components/Modules-revamp/Visible';
import { Field, Form } from '@/src/components/RcForm';
import { EPreviewSize } from '@/src/types/common/SalesChannel';
import { debounce } from 'lodash';
import { EnumModuleType } from '../common';

const moduleRender = (type: EnumModuleType, props: any) => {
  switch (type) {
    case EnumModuleType.ResponsiveImageCarousel: {
      return <ImageCarouselRender {...props} />;
    }
    case EnumModuleType.ResponsiveProductCarousel: {
      return <ProductCarouselRender {...props} />;
    }
    case EnumModuleType.ResponsiveContentCarousel: {
      return <ContentCarouselRender {...props} />;
    }
    case EnumModuleType.ResponsivePoster: {
      return <PosterRender {...props} />;
    }
    case EnumModuleType.ResponsiveText: {
      return <TextRender {...props} />;
    }
    case EnumModuleType.ResponsiveSubscription: {
      return <SubscriptionRender {...props} />;
    }
    case EnumModuleType.ResponsiveProductGrid: {
      return <ProductGridRender {...props} />;
    }
    case EnumModuleType.ResponsiveContentGrid: {
      return <ContentGridRender {...props} />;
    }
    case EnumModuleType.ResponsivePosterTab: {
      return <PosterTabRender {...props} />;
    }
    case EnumModuleType.ResponsiveProductTab: {
      return <ProductTabRender {...props} />;
    }
    case EnumModuleType.ResponsiveContentTab: {
      return <ContentTabRender {...props} />;
    }
    case EnumModuleType.ResponsiveIframe: {
      return <IframeRender {...props} />;
    }
  }
};

const ModuleRender = ({ form, breakpoint, ...extra }) => {
  return (
    <Field name={'moduleType'}>
      {(props, meta, { getFieldValue }) => {
        const moduleType = getFieldValue('moduleType');
        return <>{moduleRender(moduleType, { form, breakpoint, ...extra })}</>;
      }}
    </Field>
  );
};

const contentRender = ({
  pcForm,
  mobileForm,
  tabletForm,
  seoSettingForm,
  selectedItem,
  handlePCFormValuesChange,
  handleOnSectionReset,
  handleOnSectionCopy,
  salesChannelMode,
  disabled,
}) => {
  if (selectedItem === seoSetting) {
    return [
      {
        child: (
          <Form form={seoSettingForm}>
            <HomePageSEOSetting
              isPrimary
              titleKey={seoSettingKey.title}
              descriptionKey={seoSettingKey.description}
              faviconKey={seoSettingKey.favicon}
              disabled={disabled}
            />
          </Form>
        ),
        key: seoSetting,
      },
    ];
  }

  const commonProps = {
    handleOnSectionReset,
    handleOnSectionCopy,
    salesChannelMode,
    disabled,
  };

  return [
    {
      child: (
        <Form
          form={pcForm}
          onValuesChange={debounce(handlePCFormValuesChange, 200)}>
          <Visible
            breakpoint={EPreviewSize.WIDE}
            translateDisabled={disabled}
          />
          <ErrSection breakpoint={EPreviewSize.WIDE} form={pcForm} />
          <ModuleRender
            form={pcForm}
            breakpoint={EPreviewSize.WIDE}
            {...commonProps}
          />
        </Form>
      ),
    },
    {
      child: (
        <Form
          form={tabletForm}
          onValuesChange={(p) => {
            return;
          }}>
          <Visible
            breakpoint={EPreviewSize.TABLET}
            translateDisabled={disabled}
          />
          <ErrSection breakpoint={EPreviewSize.TABLET} form={tabletForm} />
          <ModuleRender
            form={tabletForm}
            breakpoint={EPreviewSize.TABLET}
            {...commonProps}
          />
        </Form>
      ),
    },
    {
      child: (
        <Form
          form={mobileForm}
          onValuesChange={(p) => {
            return;
          }}>
          <Visible
            breakpoint={EPreviewSize.MOBILE}
            translateDisabled={disabled}
          />
          <ErrSection breakpoint={EPreviewSize.MOBILE} form={mobileForm} />
          <ModuleRender
            form={mobileForm}
            breakpoint={EPreviewSize.MOBILE}
            {...commonProps}
          />
        </Form>
      ),
    },
  ];
};

export { contentRender };
